/* eslint-disable react-hooks/exhaustive-deps */
import { RESOURCE_MODULE_IDS } from "config/constants";
import { USER_ROLES } from "config/userPermissions";
import { useEffect, useState } from "react";

const useResourceModuleIdOfUser = userRole => {
	const [resourceModuleId, setResourceModuleId] = useState(0);
	//#region Effects
	useEffect(() => {
		setResourceModuleId(getResourceModuleId());
	}, [userRole]);
	//#endregion
	//#region Functions
	function getResourceModuleId() {
		if (isLibraryUser())
			return RESOURCE_MODULE_IDS.LIBRARY;
		if (isUniversitySpaceUser())
			return RESOURCE_MODULE_IDS.UNIVERSITY_SPACES;
		return 0;
	}
	function isLibraryUser() {
		return [
			USER_ROLES.RECURSOS_BIBLIOTECA_COORDINADOR
		].includes(userRole);
	}
	function isUniversitySpaceUser() {
		return [
			USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_GENERAL,
			USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_CAMPUS,
			USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS
		].includes(userRole);
	}
	//#endregion
	return resourceModuleId;
}	
	
export default useResourceModuleIdOfUser;